module.exports=function(scope){ return `${scope.fClient}
${scope.fBranch}
${scope.fDate}
${scope.fTerms}
${scope.fComment}`};